import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function HouseAgentCancel() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const workOrderId = searchParams.get('order');

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center" data-testid="house-agent-cancel-page">
      <div className="max-w-lg mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-3">Payment Cancelled</h1>
          <p className="text-zinc-400 mb-8">
            Your payment was cancelled and no charges were made. The AI work order has been discarded.
          </p>

          {workOrderId && (
            <p className="text-sm text-zinc-500 mb-8">
              Order reference: {workOrderId.slice(0, 8)}...
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/agents')}
              variant="outline"
              className="border-white/20 text-zinc-300"
              data-testid="browse-agents-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Browse Agents
            </Button>
            <Button
              onClick={() => navigate(-1)}
              className="bg-cyan-500 hover:bg-cyan-600"
              data-testid="try-again-btn"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
